import {
    connect,
    injectSaga,
} from '@vfde-fe/sails_core';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-fe/sails-constants';
import {
    CONTAINER_OPTIONS,
} from 'Constant';
import { selectHardwareOnly, selectName } from '../DeviceDetail/selectors';
import optionsSaga from './saga';
import { createStructuredSelector } from 'reselect';
import {
    selectAtomicId,
    selectCapacities,
    selectCapacitiesForColor,
    selectColors,
    selectCurrentCapacity,
    selectCurrentColor,
    selectDeliveryDate,
    selectDeliveryScope, selectForceRerender,
    selectImages,
    selectTechnicalDetails,
} from './selectors';
import { mountColorOptionPicker } from '../../components/mountColorOptionPicker';
import { mountCapacityOptionPicker } from '../../components/mountCapacityOptionPicker';
import mountImageGallery from '../../components/mountImageGallery';
import mountIconText, { updateDeliveryDate } from '../../components/mountIconText';
import { mountTechnicalDetailsAccordion } from '../../components/mountTechnicalDetailsAccordion';
import { IInitialState as IInitialStateOptions, StateProps } from './interfaces/state';
import {
    DELIVERY_DATE_CONTAINER,
    DELIVERY_DATE_MOBILE_CONTAINER,
    COLOR_PICKER_CONTAINER,
    CAPACITY_PICKER_CONTAINER,
    IMAGE_GALLERY_CONTAINER,
} from './constants';
import { IInitialState as IInitialStateDeviceDetail } from '../DeviceDetail/interfaces/state';
import { RootState } from '@vfde-fe/sails_core';
import { OptionsActionDispatchers, optionsActionDispatchers } from './actions';

function Options (state: StateProps, actions: OptionsActionDispatchers) {
    injectSaga(CONTAINER_OPTIONS, optionsSaga);

    // Set initial color and capacity from session storage or default (first) value in API
    actions.setDefaultState(window[ADDITIONAL_PAGE_OPTIONS]);

    const deliveryDate = mountIconText(DELIVERY_DATE_CONTAINER);
    const deliveryDateMobile = mountIconText(DELIVERY_DATE_MOBILE_CONTAINER);
    mountColorOptionPicker(COLOR_PICKER_CONTAINER, state, actions.changeColor);
    mountCapacityOptionPicker(CAPACITY_PICKER_CONTAINER, state, actions.changeCapacity);

    let isFirstAccordionMount = true;

    return {
        getDerivedStateFromProps (newState: StateProps, oldState: StateProps) {
            const {atomicId} = newState;
            const atomicIdUpdated = atomicId !== oldState.atomicId;

            if (newState.availableCapacities && newState.availableCapacities) {
                mountCapacityOptionPicker(CAPACITY_PICKER_CONTAINER, newState, actions.changeCapacity);
            }

            if (newState.currentColor && newState.currentColor !== oldState.currentColor) {
                mountImageGallery(IMAGE_GALLERY_CONTAINER, newState.images!);
                mountColorOptionPicker(COLOR_PICKER_CONTAINER, newState, actions.changeColor);
            }

            if (newState.atomicId && atomicIdUpdated) {
                mountTechnicalDetailsAccordion(newState.technicalDetails, newState.deliveryScope!, isFirstAccordionMount);
                deliveryDate && updateDeliveryDate(deliveryDate, newState.deliveryDate!.shippingDate);
                deliveryDateMobile && updateDeliveryDate(deliveryDateMobile, newState.deliveryDate!.shippingDate);

                isFirstAccordionMount = false;
            }
        },
    };
}
const mapStateToProps = createStructuredSelector<RootState<IInitialStateOptions & IInitialStateDeviceDetail>, StateProps>({
    colors: selectColors(),
    capacities: selectCapacities(),
    availableCapacities: selectCapacitiesForColor(),
    currentColor: selectCurrentColor(),
    currentCapacity: selectCurrentCapacity(),
    images: selectImages(),
    atomicId: selectAtomicId(),
    technicalDetails: selectTechnicalDetails(),
    deliveryDate: selectDeliveryDate(),
    deliveryScope: selectDeliveryScope(),
    isHardwareOnly: selectHardwareOnly(),
    name: selectName(),
    forceRerender: selectForceRerender(),
});

const mountOptionsContainer = connect(mapStateToProps, optionsActionDispatchers)(Options);

export default mountOptionsContainer;
